// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"76a3be01","160":"db85347c","208":"4d419b4e","293":"022875e4","516":"3e462b5b","519":"b9f7d1b2","917":"45d63e1a","946":"d372f591"}[chunkId] + ".chunk.js";
};